import { render, staticRenderFns } from "./copy-to-term-semester.vue?vue&type=template&id=220d169a"
import script from "./copy-to-term-semester.vue?vue&type=script&lang=js"
export * from "./copy-to-term-semester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports